export default function PlumbingSystemsElPaso() {
  const systems = [
    {
      title: 'Hard Water Solutions',
      description: 'El Paso\'s hard water requires specialized treatment systems to protect pipes and fixtures from mineral buildup.',
      image: 'https://public.readdy.ai/ai/img_res/07c1a05cd0251af3f83a4f1113f4f9cd.jpg',
      benefits: ['Extends Fixture Life', 'Reduces Scale Buildup', 'Improves Water Quality', 'Protects Appliances']
    },
    {
      title: 'Tankless Water Heaters',
      description: 'Energy-efficient tankless systems perfect for El Paso\'s climate, providing endless hot water while reducing utility costs.',
      image: 'https://readdy.ai/api/search-image?query=Modern%20tankless%20water%20heater%20installation%20on%20wall%20in%20El%20Paso%20home%2C%20compact%20energy-efficient%20unit%20with%20professional%20plumbing%20connections%2C%20clean%20garage%20or%20utility%20room%20setting%2C%20bright%20lighting%20showing%20sleek%20contemporary%20design%2C%20emphasis%20on%20space-saving%20technology%20and%20energy%20efficiency&width=600&height=400&seq=plumbing-system-002&orientation=landscape',
      benefits: ['Endless Hot Water', 'Energy Savings', 'Space Efficient', 'Long Lifespan']
    },
    {
      title: 'Low-Flow Fixtures',
      description: 'Water-conserving fixtures help El Paso homeowners reduce consumption while maintaining excellent performance.',
      image: 'https://readdy.ai/api/search-image?query=Modern%20low-flow%20bathroom%20fixtures%20in%20contemporary%20El%20Paso%20home%2C%20water-efficient%20faucets%20and%20showerheads%20with%20sleek%20chrome%20finish%2C%20beautiful%20bathroom%20interior%20with%20clean%20design%2C%20bright%20natural%20lighting%20emphasizing%20water%20conservation%20technology%20and%20contemporary%20style&width=600&height=400&seq=plumbing-system-003&orientation=landscape',
      benefits: ['Lower Water Bills', 'Eco-Friendly', 'Modern Design', 'Rebate Eligible']
    },
    {
      title: 'Sewer Line Protection',
      description: 'Advanced sewer line solutions protect against El Paso\'s shifting soil and tree root intrusion.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20sewer%20line%20inspection%20equipment%20and%20camera%20system%2C%20plumber%20using%20advanced%20video%20technology%20to%20inspect%20underground%20pipes%2C%20modern%20diagnostic%20tools%20on%20residential%20property%2C%20bright%20outdoor%20setting%20showing%20professional%20service%2C%20emphasis%20on%20preventive%20maintenance%20and%20technology&width=600&height=400&seq=plumbing-system-004&orientation=landscape',
      benefits: ['Prevent Backups', 'Early Detection', 'Trenchless Repair', 'Long-Term Protection']
    }
  ];

  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Plumbing Systems for El Paso Homes
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Specialized plumbing solutions designed for El Paso's unique water conditions, climate, and infrastructure challenges.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {systems.map((system, index) => (
            <div key={index} className="bg-white rounded-xl border-2 border-gray-200 overflow-hidden hover:shadow-xl transition-all">
              <div className="relative h-64">
                <img 
                  src={system.image}
                  alt={system.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-3">{system.title}</h3>
                <p className="text-gray-600 mb-6 leading-relaxed">{system.description}</p>
                <div className="grid grid-cols-2 gap-3">
                  {system.benefits.map((benefit, idx) => (
                    <div key={idx} className="flex items-center gap-2">
                      <i className="ri-check-double-line text-blue-600"></i>
                      <span className="text-sm text-gray-700">{benefit}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
